export default __webpack_public_path__ + "static/media/11.de130546.svg";